import { useFarm } from 'app/agriculture/hooks/useFarm/useFarm';
import { useLocationState } from 'app/agriculture/router/useLocationState';
import { z } from 'zod';
import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';

const locationStateSchema = z
    .object({ initialWeatherStationId: z.string().nullable().optional() })
    .nullable();

export function useInitialWeatherStationId(): string | null {
    const { farm } = useFarm();
    const weatherStations = useDevicesByType('Weather Station');
    const { initialWeatherStationId } = useLocationState(locationStateSchema) ?? {};

    const [[, firstWeatherStation] = []] = [...weatherStations];

    return initialWeatherStationId ?? farm.weatherStation ?? firstWeatherStation?.id ?? null;
}
